import "./styles.scss";

import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { useFaq } from "context/client/faq";

const FaqFilters = () => {
  const { t } = useTranslation();

  const { data, filter, setFilter } = useFaq();

  const filters = data.reduce(
    (acc, item) =>
      !acc.some((element) => element.slug === item.category.slug)
        ? [...acc, { ...item.category }]
        : acc,
    []
  );

  return (
    <ul className="faq-filters">
      <li>
        <button
          className={classnames({ active: filter === "" })}
          type="button"
          onClick={() => setFilter("")}
        >
          {t("All")}
        </button>
      </li>
      {filters.map(({ slug, title }) => (
        <li key={slug}>
          <button
            className={classnames({ active: slug === filter })}
            type="button"
            onClick={() => setFilter(slug)}
          >
            {title}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default FaqFilters;
